import { useNavigate, useLocation } from 'react-router-dom'

export const usePreserveQueryParamsNavigate = () => {
  const navigate = useNavigate()
  const { search } = useLocation()

  return (path) => {
    navigate(path + search)
  }
}
